<template>
  <div v-if="data">
    <!--<div class="text-center" v-if="LoadingSpiner">
        <div class="loader-container">
            <div class="item-1"></div>
            <div class="item-2"></div>
            <div class="item-3"></div>
            <div class="item-4"></div>
            <div class="item-5"></div>
        </div>
    </div>-->
    <div class="loader">
      <div class="square-spin">
        <div><img src="../assets/img/A-White.svg"></div>
      </div>
    </div>
    <monitoring class="monitoring" @updateParent="updateMonitoring" :data="data" v-if="monitoring===1"/>
    <!--v-if="data.polstatus === 0"-->
    <table v-if="data.polstatus === 0">
      <thead id="print-header">
      <b-col sm="12" md="12" class=" row p-0" id="header-fix">
        <b-col cols="12 d-md-flex pt-md-4 ">
          <div class="header header_logo col-md-2 col-sm-12 p-0 d-flex justify-content-center">

            <template v-if="this.isGeo === 1">
              <img src="../assets/img/ardi_logo_white.svg" width="200" height="45" class="ardi-logo-sm">
            </template>
            <template v-else>
              <img src="../assets/img/logoEn.png" height="50" class="mt-1 ardi-logo-sm">
            </template>
          </div>

          <div class=" header header_text col-lg-8 col-md-8 p-0 value-background-header">
            <div class="d-md-flex justify-content-md-between ">
              <template v-if="this.isGeo === 1">
                <img src="../assets/img/ardi_logo.svg" height="40" class="ardi-logo mt-2 ml-3">
              </template>
              <template v-else>
                <img src="../assets/img/logoEn1.svg" height="40" class="ardi-logo mt-2 ml-3">
              </template>

              <h6 class="nino-mtavruli desc-vit mt-md-4 sm-pad">{{ $t('vitslogan') }}</h6>
            </div>
          </div>
        </b-col>
      </b-col>
      </thead>

      <tbody class="print-body" v-if="monitoring===0">

      <b-row class="mt-3 p-md-0 col-md-8 col-sm-11 mb-5">
        <b-col cols="12" offset-md="3" offset-sm="1" class=" form-font p-md-0">
          <div class="p-md-0 ">
            <b-col cols="12" offset="0" class="pt-3  pr-md-4 ">
              <b-row>

                <!--Insurer-->
                <b-col md="12" sm="12" class="p-2 content-header ">
                  <div class="col-md-10 col-sm-12 offset-md-3 text-center nino-mtavruli">{{ $t('Insurer') }}</div>
                </b-col>
                <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('companyname') }}</b-col>
                <b-col md="8" sm="12" class="value-background p-2 ">
                  <div class="text-center">
                    <div>{{ $t('JSCardi') }}</div>
                  </div>
                </b-col>
                <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('taxnumber') }}</b-col>
                <b-col md="8" sm="12" class="value-background p-2 ">
                  <div class="text-center">

                    <div>{{ data.compsoccart }}</div>
                  </div>
                </b-col>

                <b-col md="12" sm="12" class="mt-3 p-2 content-header ">
                  <div class="col-md-10 col-sm-12 offset-md-3 text-center nino-mtavruli">{{ $t('policyholder') }}</div>
                </b-col>
                <b-col md="4" sm="12" class="description p-2 value-border-top">
                  {{ $t('namesurname') }}
                </b-col>
                <b-col md="8" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.customerName }}</div>
                </b-col>
                <b-col md="4" sm="12" class="description p-2 value-border-top"> {{ $t('bday') }}</b-col>
                <b-col md="8" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.customerBirthday }}</div>
                </b-col>
                <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('pnumber') }}</b-col>
                <b-col md="8" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.customerSocCard }}</div>
                </b-col>
                <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('address') }}</b-col>
                <b-col md="8" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.cstomerAddress }}</div>
                </b-col>
                <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('mob') }}</b-col>
                <b-col md="8" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.customerPhone }}</div>
                </b-col>
                <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('email') }}</b-col>
                <b-col md="8" sm="12" class="value-background p-2  ">
                  <div class="text-center">{{ data.customerEMail }}</div>
                </b-col>
                <template v-for="(item,index) in data.owner"
                          v-if="item.ownerName !== null || item.ownerBirthday !== null || item.ownerSocCard !== null">
                  <b-col md="12" sm="12" class="mt-3 p-2 content-header nino-mtavruli ">
                    <div class="col-md-10 col-sm-12 offset-md-3 text-center nino-mtavruli">
                      {{ $t('beneficiary') }} {{ index + 1 }}
                    </div>
                  </b-col>
                  <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('usernamesurname') }}</b-col>
                  <b-col md="8" sm="12" class="value-background p-2  ">
                    <div class="text-center">{{ item.ownerName }}</div>
                  </b-col>
                  <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('bday') }}</b-col>
                  <b-col md="8" sm="12" class="value-background p-2  ">
                    <div class="text-center"> {{ item.ownerBirthday }}</div>
                  </b-col>
                  <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('idnumber') }}</b-col>
                  <b-col md="8" sm="12" class="value-background p-2  ">
                    <div class="text-center">{{ item.ownerSocCard }}</div>
                  </b-col>
                </template>


                <b-col md="12" sm="12" class="mt-3 p-2 content-header nino-mtavruli ">
                  <div class="col-sm-12   nino-mtavruli">{{ $t('selectedvitamin') }}</div>
                </b-col>

                <b-col class="col-12 value-background-main p-0">
                  <b-col class="check_box d-sm-block d-md-flex justify-content-md-around p-2">
                    <div class="border-bottom-sm inline-sm ">
                      <span class="hide-text-md">{{ $t('vitamin') }} A</span>
                      <template v-if="data.v1 == 1">
                        <b-form-checkbox v-model="checked" class="d-md-flex justify-content-md-around pointer-none"
                                         size="lg"></b-form-checkbox>
                      </template>
                      <template v-else>
                        <b-form-checkbox class="d-md-flex justify-content-md-around pointer-none"
                                         size="lg"></b-form-checkbox>
                      </template>
                      <span class="hide-text-sm d-md-block " style="margin-top: 10px">{{ $t('vitamin') }} A</span>
                    </div>
                    <div class=" border-bottom-sm inline-sm">
                      <span class="hide-text-md">{{ $t('vitamin') }} B</span>
                      <template v-if="data.v2 == 1">
                        <b-form-checkbox v-model="checked" class="d-md-flex justify-content-md-around pointer-none"
                                         size="lg"></b-form-checkbox>
                      </template>
                      <template v-else>
                        <b-form-checkbox class="d-md-flex justify-content-md-around pointer-none"
                                         size="lg"></b-form-checkbox>
                      </template>
                      <span class="hide-text-sm d-md-block " style="margin-top: 10px">{{ $t('vitamin') }} B</span>
                    </div>
                    <div class="border-bottom-sm inline-sm">
                      <span class="hide-text-md">{{ $t('vitamin') }} C</span>
                      <template v-if="data.v3 == 1">
                        <b-form-checkbox v-model="checked" class="d-md-flex justify-content-md-around pointer-none"
                                         size="lg"></b-form-checkbox>
                      </template>
                      <template v-else>
                        <b-form-checkbox class="d-md-flex justify-content-md-around pointer-none"
                                         size="lg"></b-form-checkbox>
                      </template>
                      <span class="hide-text-sm d-md-block " style="margin-top: 10px">{{ $t('vitamin') }} C</span>
                    </div>
                    <div class="border-bottom-sm inline-sm ">
                      <span class="hide-text-md">{{ $t('vitamin') }} D</span>
                      <template v-if="data.v4 == 1">
                        <b-form-checkbox v-model="checked" class="d-md-flex justify-content-md-around pointer-none"
                                         size="lg"></b-form-checkbox>
                      </template>
                      <template v-else>
                        <b-form-checkbox class="d-md-flex justify-content-md-around pointer-none"
                                         size="lg"></b-form-checkbox>
                      </template>
                      <span class="hide-text-sm d-md-block " style="margin-top: 10px">{{ $t('vitamin') }} D</span>
                    </div>
                    <div class="inline-sm">
                      <span class="hide-text-md ">{{ $t('vitamin') }} E</span>
                      <template v-if="data.v5 == 1">
                        <b-form-checkbox v-model="checked" class="d-md-flex justify-content-md-around pointer-none"
                                         size="lg"></b-form-checkbox>
                      </template>
                      <template v-else>
                        <b-form-checkbox class="d-md-flex justify-content-md-around pointer-none"
                                         size="lg"></b-form-checkbox>
                      </template>
                      <span class="hide-text-sm d-md-block " style="margin-top: 10px">{{ $t('vitamin') }} E</span>
                    </div>

                  </b-col>

                </b-col>


                <div class="mt-3 col-md-12 col-sm-12">

                  <div class="row value-background-main">
                    <b-col class="col-md-4 p-0 value-background-sm">
                      <div class="content-header  p-2 nino-mtavruli text-center">{{ $t('waitingperiod') }}</div>
                      <b-col class="p-2 d-flex">
                        <div class="col-sm-6  p-0 d-flex right-border-sm  pl-md-5 justify-content-center  ">
                          <span class="marg-text1">{{ $t('yes') }}</span>
                          <template v-if="data.checkBox1 == 1">
                            <b-form-checkbox v-model="checked" class="pointer-none" id="waiting_period_yes pointer-none"
                                             size="lg"></b-form-checkbox>
                          </template>
                          <template v-else>
                            <b-form-checkbox class="pointer-none" id="waiting_period_yes pointer-none"
                                             size="lg"></b-form-checkbox>
                          </template>
                        </div>
                        <div class="col-sm-6 p-0 d-flex  justify-content-center pr-md-3 ">
                          <span class="marg-text1 ">{{ $t('no') }}</span>
                          <template v-if="data.checkBox1 == 0">
                            <b-form-checkbox v-model="checked" id="waiting_period_no pointer-none" class="pointer-none"
                                             size="lg"></b-form-checkbox>
                          </template>
                          <template v-else>
                            <b-form-checkbox class="pointer-none" id="waiting_period_no pointer-none"
                                             size="lg"></b-form-checkbox>
                          </template>
                        </div>
                      </b-col>
                    </b-col>


                    <div class="col-md-8 col-sm-12 p-0 marg-top">
                      <div class=" content-header p-2 nino-mtavruli text-center">
                        {{ $t('servicescheme') }}
                      </div>
                      <b-col
                          class="col-md-12 col-sm-12  p-2 sm_display text-center d-sm-block d-md-flex justify-content-md-around ">
                        <div class="d-flex justify-content-between border-bottom-sm pl-md-5">
                          <span class="marg-text1">{{ $t('byfamilydoctor') }}</span>
                          <template v-if="data.checkBox2 == 1">
                            <b-form-checkbox v-model="checked" id="family_doctor" class="pointer-none"
                                             size="lg"></b-form-checkbox>
                          </template>
                          <template v-else>
                            <b-form-checkbox id="family_doctor" class="pointer-none" size="lg"></b-form-checkbox>
                          </template>
                        </div>
                        <div class="d-flex justify-content-between pr-md-5">
                          <span class="marg-text1">{{ $t('freechoice') }}</span>
                          <template v-if="data.checkBox2 == 0">
                            <b-form-checkbox v-model="checked" id="family_doctor" class="pointer-none"
                                             size="lg"></b-form-checkbox>
                          </template>
                          <template v-else>
                            <b-form-checkbox id="family_doctor" class="pointer-none" size="lg"></b-form-checkbox>
                          </template>
                        </div>

                      </b-col>
                    </div>
                  </div>
                </div>

                <div class="mt-3 col-md-12 col-sm-12 value-background text-center">
                  <b-row>
                    <b-col class="row">
                      <div class=" col-md-6 description-box p-2 height-sm-premium">{{ $t('yearpremium') }}</div>
                      <div class="col-md-6 right-border p-2">{{ data.insurancePremiums }}</div>
                    </b-col>
                    <b-col class="row ">
                      <div class=" col-md-6  description-box p-2 height-sm-premium">{{ $t('paymentcount') }}</div>
                      <div class="nino-mtavruli col-md-6  p-2">{{ data.paymentCount }}</div>
                    </b-col>

                  </b-row>
                </div>


                <b-col class="col-12 mt-3  content-header  text-center bo mt-1 nino-mtavruli p-2">
                  {{ $t('paymentschedule') }}
                </b-col>

                <!--responsive-->
                <div class=" col-md-12 col-sm-12  text-center payment-sm">
                  <b-row>
                    <b-col class="row col-md-6 ">
                      <div class="nino-mtavruli col-sm-6 pay-head-border payment-title back-color-pay">
                        {{ $t('date') }}
                      </div>
                    </b-col>
                    <b-col class="row col-md-6 ">
                      <div class="col-sm-6 pl-1 pay-head-border payment-title  back-color-pay">
                        {{ $t('amount') }}
                      </div>
                    </b-col>


                  </b-row>

                  <template v-for="i in data.payment" v-if="i.payDate != null || i.payAmaunt != null">
                    <b-row>
                      <b-col class="row col-md-6">
                        <div class="nino-mtavruli col-md-6 right-border payment-sm-border ">{{ i.payDate }}</div>

                      </b-col>
                      <b-col class="row col-md-6">
                        <div class="nino-mtavruli col-md-6 payment-sm-border">{{ i.payAmaunt }}</div>
                      </b-col>
                    </b-row>
                  </template>
                </div>
                <!--                one payment-->
                <div class="col-12  payment-md ">

                  <div class="row payment-md-border " v-if="data.payment.length<2">
                    <template v-for="i in data.payment">


                      <div class="col-3   payment-title nino-mtavruli back-color-pay">
                        {{ $t('date') }}
                      </div>
                      <div class="col-3 value-background">
                        {{ i.payDate }}
                      </div>
                      <div class="nino-mtavruli col-3 back-color-pay">
                        {{ $t('amount') }}
                      </div>
                      <div class="col-3 value-background">
                        {{ i.payAmaunt }}
                      </div>
                    </template>
                  </div>
                </div>

                <!--multiple payment-->

                <div class="col-12 row  p-0 m-0 payment text-center" v-if="data.payment.length>=2">
                  <div class="col-md-6 p-0">
                    <div class="col-md-12 row m-0 p-0 payment-md ">
                      <div class="col-6 pay-head-border  payment-title  back-color-pay pay-border-left">
                        {{ $t('date') }}
                      </div>
                      <div class="col-6 pay-head-border payment-title  back-color-pay">
                        {{ $t('amount') }}
                      </div>
                      <template v-for="i in data.payment.slice(0, Math.round( data.payment.length/2))">

                        <div class="col-6 green-border pay-border-left">
                          {{ i.payDate }}
                        </div>
                        <div class="col-6 green-border">
                          {{ i.payAmaunt }}
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="col-md-6 p-0">
                    <div class="col-md-12 row m-0 p-0 payment-md text-center">
                      <div class="col-6 pay-head-border payment-title back-color-pay">
                        {{ $t('date') }}
                      </div>
                      <div class="col-6 pay-head-border payment-title back-color-pay">
                        {{ $t('amount') }}
                      </div>

                      <template v-for="i in data.payment.slice(Math.round(data.payment.length/2), data.payment.length)">
                        <div class="col-6 green-border">
                          {{ i.payDate }}
                        </div>
                        <div class="col-6 green-border">
                          {{ i.payAmaunt }}
                        </div>
                      </template>

                      <!--<template v-if="data.payment.length % 2 !== 0">
              <div class="col-6 green-border value-hide"> {{ emptyvalue }}</div>
              <div class="col-6 green-border value-hide"> {{ emptyvalue }}</div>
          </template>-->

                    </div>

                  </div>
                </div>

                <b-col md="12" sm="12" class="mt-3 ">
                  <b-row style="font-size: 12px">
                    <div class="col-sm-12 col-md-3 description-box p-2">{{ $t('placeofissue') }}</div>
                    <div class="col-sm-12 col-md-3 value-background p-2">{{ $t('tbilisi') }}</div>
                    <div class="col-sm-12 col-md-3 description-box p-2">{{ $t('dateOfissue') }}</div>
                    <div class="col-sm-12 col-md-3 value-background p-2">{{ data.contDate }}</div>
                  </b-row>
                </b-col>


                <div class="mt-3 col-md-12 col-sm-12 ">
                  <b-row style="font-size: 12px">
                    <b-col class="row ">
                      <div class="col-md-6 description-box right-border-sm p-2">{{ $t('coverfrom') }}</div>
                      <div class="col-md-6 right-border value-background p-2">{{ data.fromDate }}</div>
                    </b-col>
                    <b-col class="row ">
                      <div class="col-md-6  description-box p-2">{{ $t('including') }}</div>
                      <div class="col-md-6 value-background  p-2">{{ data.toDate }}</div>
                    </b-col>

                  </b-row>
                </div>

                <b-col class="mt-3 p-0 col-12 policy-text">
                  <!--{{ Description.VitaminDesc }}-->
                  {{ $t('vitamindesc') }}
                </b-col>

                <b-col class=" text-center mt-3 col-md-12 ">
                  <div class="row ">
                    <div class="col-md-8 nino-mtavruli  description-box p-2">{{ $t('termsofinsurance') }}</div>

                    <div class="col-md-4 text-center-url url-text-size">
                      <span style="cursor: pointer; color: -webkit-link; "
                            @click="myFunction($t('termsofinsurancelink'))">{{ data.condition }}</span>
                    </div>
                  </div>
                </b-col>


                <div class="mt-3 col-md-12 col-sm-12 d-flex justify-content-center p-0  ">
                  <b-button @click="Denial" class="mr-3 accept-text" variant="outline-danger">{{ $t('notagree') }}
                  </b-button>
                  <b-button variant="success" class="accept-text btn-width" @click="status=true">{{ $t('agree') }}
                  </b-button>
                </div>

                <b-modal v-model="denial" size="sm" :ok-title="$t('finish')" ok-only @ok="reject"
                         :title="$t('reasonrejection')">
                  <b-form-checkbox id="checkbox-2"
                                   v-model="rejectStatus"
                                   class="mt-3"
                                   value="56">
                    {{ $t('defectdata') }}
                  </b-form-checkbox>
                  <b-form-checkbox id="checkbox-3"
                                   v-model="rejectStatus"
                                   class="mt-3"
                                   value="54">
                    {{ $t('denialcondition') }}
                  </b-form-checkbox>
                </b-modal>

                <b-modal v-model="status" size="lg" hide-footer>
                  <conditions :policy="data.policyNumber"
                              :start="data.fromDate"
                              :end="data.toDate"
                              :polid="data.polId"
                              :riskdata="riskData"
                              :isgeo="this.isGeo"/>
                  <div class="col-12 text-center mt-3" style="border-top: 1px solid #dee2e6;">
                    <b-button variant="primary" size="md" class="mt-2 mr-2" @click="submit">
                      {{ $t('policydecoration') }}
                    </b-button>

                  </div>
                </b-modal>
                <b-modal v-model="slavaukraine" visible centered size="md" hide-footer :title="$t('pleaseconfirm')">
                  <img src="../assets/img/ukflag.jpg" class="centerimg">
                  <div class="col-12 text-center mt-3" style="border-top: 1px solid #dee2e6;">
                    <b-button variant="outline-info" size="md" class="mt-2" @click="status = true; slavaukraine= false">
                      <span style="color: #FFD500; ">{{ $t('glory') }} </span>
                      <span style="color: mediumblue">{{ $t('ukraina') }}</span>
                    </b-button>

                  </div>
                </b-modal>

                <b-modal v-model="status1" size="lg" :ok-title="$t('finish')" ok-only @ok="finish">
                  {{ $t('notactive') }}
                  {{ this.data.nmG_NAME_A }} {{ this.data.mnG_LASTNAME }},
                  <a :href='"tel:+995"+this.data.mnG_PHONE'>{{ this.data.mnG_PHONE }}</a>,
                  <a :href='"mailto:"+this.data.mnG_EMAIL'>{{ this.data.mnG_EMAIL }}</a>
                </b-modal>

              </b-row>
            </b-col>
          </div>

        </b-col>
      </b-row>

      <!--      <b-button @click="showCounterModal">Show modal 1</b-button>
            <b-button v-b-modal.modal-2>Show modal 2</b-button>-->

      </tbody>


      <tfoot id="print-footer" class="mb-5">
      <b-row class="m-0">
        <b-col offset-md="2" offset-sm="0" class="p-md-0 col-lg-8">
          <div class="d-flex justify-content-between mr-4  pb-4 m-lg-n3 pr-md-5">
            <template v-if="this.isGeo === 1">
              <img src="../assets/img/ardi-logo.svg" width="110">
              <img src="../assets/img/slogan.svg" width="270" class="pl-4">
            </template>
            <template v-else>
              <img src="../assets/img/logoEn1.svg" width="110">
              <div style="color: #007960;" class="slogan-sm">
                JUST THINK OF BEST
              </div>
            </template>
          </div>
        </b-col>
      </b-row>
      </tfoot>
    </table>

    <div v-if="data.polstatus === 1">
      <h1 class="text-center col-10 offset-1 mt-5">
        <span>{{ $t('confirmed') }}</span> <br/>
        {{ $t('insuranceadvisor') }} - {{ this.data.nmG_NAME_A }} {{ this.data.mnG_LASTNAME }}<br/>
        {{ $t('mob') }}: {{ data.mnG_PHONE }}<br/>
        {{ $t('email') }}: {{ data.mnG_EMAIL }}
      </h1>
    </div>
    <div v-if="data.polstatus === 2">
      <h1 class="text-center col-10 offset-1 mt-5">
        <span style="color:red">{{ $t('linkdeleted') }}</span> <br/>
        {{ $t('insuranceadvisor') }} - {{ this.data.nmG_NAME_A }} {{ this.data.mnG_LASTNAME }}<br/>
        {{ $t('mob') }}: {{ data.mnG_PHONE }}<br/>
        {{ $t('email') }}: {{ data.mnG_EMAIL }}
      </h1>
    </div>


    <b-modal ref="counter-modal"
             :title="$t('InfoModalHeader')"
             id="info-modal"
             hide-footer
             v-b-modal.modal-sm>
      <div v-html=" $t('DeadlockMessagePart') + minutes + $t('DeadlockMessagePart2') "></div>
      <b-button :disabled="minutes!==0"
                variant="success"
                @click="submit(); countdownSpinner=true">
        {{ $t('confirm') }}
        <b-spinner v-if="countdownSpinner"
                   small
                   label="Small Spinner"></b-spinner>
      </b-button>
    </b-modal>

    <b-modal id="info-modal2"
             ref="operation-modal"
             :title="$t('InfoModalHeader')"
             hide-footer
             v-b-modal.modal-sm>
      <div v-html=" $t('OperationMessage') "></div>
      <b-button @click="reloadPage()" variant="light">{{ $t('ViewPolicy') }}</b-button>
    </b-modal>

  </div>
</template>

<script>
import Descriptions from "@/assets/Descriptions.json";
import ImportantConditions from "./components/ImportantConditions";
import MonitoringForm from "./MonitoringForm";

export default {
  name: "ContractPreview",
  components: {
    'conditions': ImportantConditions,
    'monitoring': MonitoringForm
  },
  data() {
    return {
      isGeo: 0,
      emptyvalue: 1,
      Description: Descriptions.items,
      denial: false,
      status1: false,
      status2: false,
      cont: this.$route.params.cont,
      cust: this.$route.params.cust,
      checked: true,
      data: null,
      datarisk: null,
      monitoring: 1,
      status: false,
      slavaukraine: false,
      rejectStatus: null,
      LoadingSpiner: true,
      riskData: null,
      minutes: 19,
      countdown: null,
      countdownSpinner: false,
    }
  },

  mounted() {
    this.$http.get(`/policy/GetVitaminInfo/${this.cont}/${this.cust}`).then(r => {
      this.data = r.data;
      this.monitoring = r.data.ismonitoring;
      this.LoadingSpiner = false;
      if (r.data.isGeo === 1) {
        this.isGeo = 1;
      }
      console.log(r.data);
    }).catch((e) => {
      console.log(e)
    })
  },
  methods: {
    reloadPage() {
      this.$refs['operation-modal'].hide();
    },
    showCounterModal: function () {
      this.$refs['counter-modal'].show();

      this.minutes = 19;
      clearInterval(this.countdown);

      this.countdown = setInterval(() => {
        if (this.minutes != 0)
          this.minutes--;
      }, 1000);
    },
    myFunction: function (url) {
      window.open(url, "_blank");
    },
    updateMonitoring(value) {
      this.monitoring = value;
      this.LoadingSpiner = false;
    },
    Denial() {
      this.denial = true
    },
    submit() {
      //this.LoadingSpiner = true;
      document.body.classList.toggle('loader-overlay')
      this.$http.post('/policy/CreatePolicy', {
        PolId: this.$route.params.cont,
        Cust: this.$route.params.cust,
        Cont: this.$route.params.cont,
        Policy: this.data.policyNumber,
        PolicyStart: this.data.fromDate,
        PolicyEnd: this.data.toDate,
        ClientName: this.data.customerName,
        ClientEmail: this.data.customerEMail,
        ClientPhone: this.data.customerPhone,
        ManagerName: this.data.nmG_NAME_A + ' ' + this.data.mnG_LASTNAME,
        ManagerPhone: this.data.mnG_PHONE,
        ManagerEmail: this.data.mnG_EMAIL,
        ControllerName: 'vitamin',
        PlicyId: this.data.polId
      }).then((r) => {
        if (r.data.isDeadlocked) {
          this.showCounterModal();
          this.countdownSpinner = false;
        } else {
          if (r.data.isSuccess) {
            window.location = 'https://mobile.ardi.ge/api/payment/' + this.data.policyNumber.replace(' ', '')
          } else {
            this.$refs['operation-modal'].show();
          }
        }

      }).catch((e) => {
        console.log(e)
        alert("შეცდომა პოლისის ჩაწერისას");
      })
      /* let that = this;
       setTimeout(function () {
         window.location = 'https://mobile.ardi.ge/api/payment/' + that.data.policyNumber.replace(' ', '')
       }, 4000)*/


    },
    reject() {
      this.status1 = true
      this.$http.post('/policy/Reject', {
        PolId: this.$route.params.cont,
        Cust: this.$route.params.cust,
        Cont: this.$route.params.cont,
        Policy: this.data.policyNumber,
        PolicyStart: this.data.fromDate,
        PolicyEnd: this.data.toDate,
        ClientName: this.data.customerName,
        ClientEmail: this.data.customerEMail,
        ClientPhone: this.data.customerPhone,
        ManagerName: this.data.nmG_NAME_A + ' ' + this.data.mnG_LASTNAME,
        ManagerPhone: this.data.mnG_PHONE,
        ManagerEmail: this.data.mnG_EMAIL,
      }).then((r) => {
        console.log(r.data)
      }).catch((e) => {
        console.error(e)
      })
    },
    finish() {
      console.log("finish")
      this.$http.post('/policy/Reject', {
        Policy: this.data.policyNumber,
        ClientName: this.data.customerName,
        ClientEmail: this.data.customerEMail,
        ClientPhone: this.data.customerPhone,
        ManagerPhone: this.data.mnG_PHONE,
        ManagerEmail: this.data.mnG_EMAIL,
        Cont: this.$route.params.cont,
        RejectCode: parseInt(this.rejectStatus)
      }).then((r) => {
        console.log(r.data)
        window.location = 'https://ardi.ge/'
      }).catch((e) => {
        console.log(e)
      })

    }
  }
}
</script>

<style scoped>
@import "~bpg-nino-mtavruli";

.centerimg {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.nino-mtavruli {
  font-family: "BPG Nino Mtavruli", sans-serif;
}

.description-box {
  background-color: #00a987;
  color: #fff;
}

.print-body {
  margin-bottom: 5rem;
}

.monitoring {
  position: absolute;
  width: 100%;
  top: 0;
  background: #EEEEEE;
  z-index: 99;
}

button.accept-text.btn.btn-outline-danger.mr-3 {
  color: black !important;
  border-color: #dc3545 !important;
}

.url-text-size {
  font-size: 14px;
  border: 1px solid #EEEEEE;
}

.desc-vit {
  color: #007960;
  font-weight: bold;
}

table {
  width: 100%;
}

.green-border {
  border-collapse: collapse;
  border-bottom: 1px solid #41A546;
  border-right: 1px solid #41A546;
}

.pay-head-border {
  /*border: 1px solid #41A546;*/
  border-collapse: collapse;
  border-bottom: 1px solid #41A546;
  border-right: 1px solid #41A546;
}

.description-box {
  background: #007960;
  color: #fafafa;
}

.value-hide {
  color: white;
}

.right-border {
  border-right: 1px solid #EEEEEE;
}

header, h1 {
  font-size: 26px;
  color: #007960;
}

.ardi-logo {
  align-self: center;
}

#print-header {
  padding: 15px 0;
  display: table-header-group;
}


.content-header {
  background-color: #005745;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

.description {
  background-color: #007961;
  color: #fff;
  font-size: 12px;
}

.value-background {
  border: 1px solid #EEEEEE;
  font-size: 12px;
}

.value-background-main {
  border: 1px solid #EEEEEE;
  font-size: 12px;
  background-color: #fafafa !important;
}

.value-background-header {
  background-color: #fafafa !important;
  font-size: 12px;
}


.value-border-top {
  border-top: 1px solid #00A788;
}

.marg-text1 {
  margin-top: 5px;
  margin-right: 10px;
}

.ardi-logo-sm {
  display: none;
}

.btn-width {
  width: 130px;
}

.payment-sm {
  display: none;
}

.pay-border-left {
  border-left: 1px solid #41A546;
}

.text-center-url {
  height: 38px;
  text-align: center;
  vertical-align: middle;
  line-height: 38px;
}

.payment-md-border {
  border: 1px solid #00A886;
  border-collapse: collapse;
  font-size: 10pt;
}

.pointer-none {
  pointer-events: none !important;
}

.back-color-pay {
  background-color: #D0AAD9;
  color: #FAFAFA;
}

.hide-text-md {
  display: none;
}

.policy-text {
  font-size: 12px;
}

.accept-text {
  font-size: 14px;
}

.custom-checkbox.b-custom-control-lg ::before, .input-group-lg .custom-checkbox ::before {
  border-color: #2AAB6E !important;
}

.loader {
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -ms-flex-preferred-size: 25%;
  flex-basis: 25%;
  max-width: 25%;
  height: 200px;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  display: none;
}

.loader-overlay {
  overflow: hidden
}

.loader-overlay .loader {
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 333;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 99999999;
}

.loader-overlay {
  position: relative;
  width: 100%;
  height: 100%;
  /* background: #ccc; */
  z-index: 999;
}

.loader-overlay:after {
  position: fixed;
  content: '';
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #efefef91;
  z-index: 9999999;
}

.square-spin > div {
  width: 50px;
  height: 50px;
  background: #00A987;
  -webkit-animation: square-spin 3s 0s cubic-bezier(.09, .57, .49, .9) infinite;
  animation: square-spin 3s 0s cubic-bezier(.09, .57, .49, .9) infinite;
}

.square-spin > div img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@-webkit-keyframes square-spin {
  25% {
    -webkit-transform: perspective(100px) rotateX(180deg) rotateY(0);
    transform: perspective(100px) rotateX(180deg) rotateY(0);
  }

  50% {
    -webkit-transform: perspective(100px) rotateX(180deg) rotateY(180deg);
    transform: perspective(100px) rotateX(180deg) rotateY(180deg);
  }

  75% {
    -webkit-transform: perspective(100px) rotateX(0) rotateY(180deg);
    transform: perspective(100px) rotateX(0) rotateY(180deg);
  }

  100% {
    -webkit-transform: perspective(100px) rotateX(0) rotateY(0);
    transform: perspective(100px) rotateX(0) rotateY(0);
  }
}

@media (max-width: 500px) {
  .slogan-sm {
    font-size: 13px;
    margin-top: 9px;
  }

  .height-sm-premium {
    height: 55px;
  }

  .sm-pad {
    padding: 23px 23px;
    text-align: center;
  }

  .custom-control-label:after, .custom-control-label:before {
    position: unset !important;
  }

  .sm_display {
    display: block;
  }

  .marg-top {
    margin-top: 1rem !important;
  }

  .row {
    position: unset !important;
  }

  .border-bottom-sm {
    border-bottom: 1px solid #EEEEEE;
  }

  .value-background-sm {
    background-color: #fafafa !important;
    border: 1px solid #EEEEEE;
    font-size: 12px;
  }

  .just-sm {
    justify-content: space-between !important;
  }

  .right-border-sm {
    border-right: 1px solid #EEEEEE;
  }

  .ardi-logo {
    display: none;
  }

  .ardi-logo-sm {
    display: block;
    margin-top: 7px;
  }

  .payment-md {
    display: none;
  }

  .payment-sm {
    display: block;
  }

  .payment-sm-border {
    border: 1px solid #00A886;
    border-collapse: collapse;
    font-size: 10pt;
  }

  .inline-sm {
    display: flex;
    justify-content: space-between;
  }

  .hide-text-sm {
    display: none;
  }

  .hide-text-md {
    display: block;
  }
}
</style>